import { useContext } from "react"

import classNames from "classnames"

import {
  WidgetTag,
  isComparisonActive,
  isInPlaceEditingActive,
  provideComponent
} from "scrivito"
import { DataBatchContext } from "shared/context/DataBatchContext"
import { Alignment } from "shared/lib/layout/Alignment"
import { getAlignmentContainerClassName } from "shared/lib/layout/getAlignmentContainerClassname"
import { getAlignmentContentClassName } from "shared/lib/layout/getAlignmentContentClassname"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"

import { DataLoadMoreButtonWidget } from "./DataLoadMoreButtonWidgetClass"

provideComponent(DataLoadMoreButtonWidget, ({ widget }) => {
  const { hasMore, loadMore } = useContext(DataBatchContext)

  const className = classNames(
    {
      "mt-4": !!widget.get("marginTop"),
      "mb-4": !!widget.get("marginBottom"),
      "opacity-50": !hasMore()
    },
    getAlignmentContentClassName(widget.get("alignment") as Alignment)
  )

  const containerClassName = getAlignmentContainerClassName(
    widget.get("alignment") as Alignment
  )

  if (!hasMore()) {
    if (!isInPlaceEditingActive() && !isComparisonActive()) return null

    return (
      <WidgetTag className={containerClassName}>
        <Button
          variant={widget.get("variant") || undefined}
          className={className}
        >
          {widget.get("title")}
        </Button>
      </WidgetTag>
    )
  }

  return (
    <WidgetTag className={containerClassName}>
      <Button
        variant={widget.get("variant") || ButtonVariant.PRIMARY}
        className={className}
        onClick={loadMore}
      >
        {widget.get("title")}
      </Button>
    </WidgetTag>
  )
})
